// Mock data for JRT Chideme Media website

export const testimonials = [
  {
    id: 1,
    name: "Danny Davies",
    business: "Chef Compliance UK",
    role: "Founder & Food Safety Consultant",
    content: "JRT Chideme Media transformed our digital presence from virtually invisible to industry-leading. Their strategic social media management and targeted content helped us reach food businesses across the UK who desperately needed our HACCP compliance systems. Our enquiries increased by 280% in just 4 months!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  }
];

export const targetAudiences = [
  {
    id: 1,
    title: "Freelancers & Solopreneurs",
    description: "Independent consultants and service providers who need professional personal branding to stand out in a competitive market.",
    benefits: ["Personal brand development", "LinkedIn optimization", "Professional content creation"]
  },
  {
    id: 2,
    title: "Small Service Providers",
    description: "Local trades, salons, cafes, and shops looking to enhance their local SEO and build a strong social media presence.",
    benefits: ["Local SEO boost", "Social media management", "Community engagement"]
  },
  {
    id: 3,
    title: "Independent Creatives",
    description: "Artists, TikTokers, and YouTubers requiring content distribution strategies and monetization support.",
    benefits: ["Content strategy", "Platform optimization", "Monetization guidance"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Accessible Pricing",
    description: "High-tier marketing strategies without the traditional agency price tag. We believe quality shouldn't be exclusive."
  },
  {
    id: 2,
    title: "Personalized Service",
    description: "You're not just a number. We work closely with each client to understand their unique vision and goals."
  },
  {
    id: 3,
    title: "AI-Enhanced Efficiency",
    description: "Leveraging cutting-edge AI tools to deliver faster results while maintaining creative excellence."
  },
  {
    id: 4,
    title: "Proven Results",
    description: "Our data-driven approach ensures measurable growth in your digital presence and business outcomes."
  }
];

export const packages = [
  {
    id: 1,
    name: "The Basic Package",
    price: "£150",
    period: "month",
    description: "Perfect for businesses starting their digital journey",
    features: [
      "Social media account management",
      "Monthly content calendar",
      "Flyer & ad design",
      "Basic engagement support",
      "Limited Facebook ad campaigns",
      "Email marketing templates",
      "Monthly analytics report"
    ],
    popular: false
  },
  {
    id: 2,
    name: "The Advanced Package",
    price: "£255",
    period: "month",
    description: "Comprehensive solution for serious growth",
    features: [
      "Everything in Basic Package",
      "Complete content creation",
      "Advanced ad campaign management",
      "Precision targeting strategies",
      "Advanced data analytics",
      "Competitor insights",
      "Priority communication",
      "Greater customization"
    ],
    popular: true
  }
];

export const addOnServices = [
  "Website creation & landing page optimization",
  "Extra social media posts & reels",
  "Premium video editing for TikTok/YouTube",
  "Custom graphic design projects",
  "SEO audit & optimization"
];

// Contact form submission handler (mock)
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      // Form submission successful (replace with actual API call when backend is ready)
      resolve({ success: true, message: "Thank you! We'll be in touch within 24 hours." });
    }, 1000);
  });
};
